var React = require('react');

function ClockIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"8.85","stroke":"#194550","strokeWidth":"1.8","key":0}),React.createElement("path",{"d":"M12 6.75L12 12.25L14.25 15","stroke":"#194550","strokeWidth":"1.8","strokeLinecap":"round","key":1})]);
}

ClockIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ClockIcon;

ClockIcon.default = ClockIcon;
